// components/UIComponents.jsx - 共享的小组件
import React from 'react';
import { theme } from '../theme';

// 信号徽章（Bullish/Bearish/Neutral）
export function SignalBadge({ signal, label }) {
  const colors = {
    bullish: { bg: 'rgba(34, 197, 94, 0.2)', border: theme.green, text: theme.green },
    bearish: { bg: 'rgba(239, 68, 68, 0.2)', border: theme.red, text: theme.red },
    neutral: { bg: 'rgba(234, 179, 8, 0.2)', border: theme.neutral, text: theme.neutral }
  };
  const c = colors[signal] || colors.neutral;

  return (
    <span style={{
      display: 'inline-flex',
      alignItems: 'center',
      gap: '10px',
      background: c.bg,
      border: '1px solid ' + c.border,
      borderRadius: '8px',
      padding: '10px 18px',
      fontSize: '17px',
      fontWeight: 700,
      color: c.text,
      textTransform: 'uppercase',
      letterSpacing: '0.5px'
    }}>
      <span style={{ width: '10px', height: '10px', borderRadius: '50%', background: c.text }} />
      {label || signal}
    </span>
  );
}

// 成交量徽章
export function VolumeBadge({ ratio }) {
  if (!ratio) return <span style={{ color: theme.textDark, fontSize: '17px' }}>N/A</span>;

  const isSurge = ratio >= 2.0;
  const color = isSurge ? theme.green : theme.textMuted;
  const bg = isSurge ? 'rgba(34, 197, 94, 0.2)' : 'rgba(139, 148, 158, 0.1)';
  const border = isSurge ? theme.green : theme.border;

  return (
    <span style={{
      display: 'inline-flex',
      alignItems: 'center',
      gap: '10px',
      background: bg,
      border: '1px solid ' + border,
      borderRadius: '8px',
      padding: '10px 18px',
      fontSize: '17px',
      fontWeight: 700,
      color: color
    }}>
      {ratio}x
    </span>
  );
}

// 情绪徽章
export function SentimentBadge({ sentiment }) {
  if (!sentiment) return <span style={{ color: theme.textDark, fontSize: '17px' }}>N/A</span>;

  const colors = { bullish: theme.green, bearish: theme.red, neutral: theme.neutral };
  const color = colors[sentiment.overall] || theme.textMuted;
  const bg = sentiment.overall === 'bullish'
    ? 'rgba(34, 197, 94, 0.2)'
    : sentiment.overall === 'bearish'
      ? 'rgba(248, 81, 73, 0.2)'
      : 'rgba(234, 179, 8, 0.2)';

  return (
    <span style={{
      display: 'inline-flex',
      alignItems: 'center',
      gap: '12px',
      background: bg,
      border: '1px solid ' + color,
      borderRadius: '8px',
      padding: '10px 18px',
      fontSize: '17px',
      fontWeight: 700,
      color: color
    }}>
      <span style={{ color: theme.green }}>{sentiment.positive}</span>
      <span style={{ color: theme.textDark }}>/</span>
      <span style={{ color: theme.neutral }}>{sentiment.neutral}</span>
      <span style={{ color: theme.textDark }}>/</span>
      <span style={{ color: theme.red }}>{sentiment.negative}</span>
    </span>
  );
}

// 变化指示器
export function ChangeIndicator({ value, fontSize = '18px' }) {
  if (value === null || value === undefined) {
    return <span style={{ color: theme.textDark, fontSize }}>N/A</span>;
  }

  const isPositive = value >= 0;
  const color = isPositive ? theme.green : theme.red;

  return (
    <span style={{ color, fontSize, fontWeight: 600 }}>
      {isPositive ? '+' : ''}{value}%
    </span>
  );
}

// 自定义 Tooltip（用于图表）
export function CustomTooltip({ active, payload, label }) {
  if (active && payload && payload.length) {
    return (
      <div style={{
        background: theme.bgCard,
        border: '1px solid ' + theme.border,
        borderRadius: '8px',
        padding: '16px 20px'
      }}>
        <p style={{ color: theme.teal, fontWeight: 600, marginBottom: '12px', fontSize: '18px' }}>
          {label}
        </p>
        {payload.map((entry, index) => (
          <p key={index} style={{ color: entry.color, fontSize: '18px', margin: '8px 0' }}>
            {entry.name}: <span style={{ fontWeight: 600 }}>${entry.value?.toFixed(2)}M</span>
          </p>
        ))}
      </div>
    );
  }
  return null;
}

// 成功页面
export function SuccessPage({ onBack }) {
  return (
    <div style={{
      minHeight: '100vh',
      background: theme.bg,
      fontFamily: '-apple-system, sans-serif',
      color: theme.text,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    }}>
      <div style={{ textAlign: 'center', maxWidth: '600px', padding: '48px' }}>
        <div style={{ fontSize: '80px', marginBottom: '24px' }}>🎉</div>
        <h1 style={{
          fontFamily: 'Georgia, serif',
          fontSize: '48px',
          color: theme.text,
          margin: '0 0 16px'
        }}>
          Welcome to Pro!
        </h1>
        <p style={{
          color: theme.textMuted,
          fontSize: '24px',
          margin: '0 0 32px',
          lineHeight: '1.6'
        }}>
          Your subscription is now active.
        </p>
        <button
          onClick={onBack}
          style={{
            background: theme.teal,
            border: 'none',
            borderRadius: '12px',
            padding: '20px 56px',
            color: '#0f172a',
            fontSize: '22px',
            fontWeight: 700,
            cursor: 'pointer'
          }}
        >
          Start Analyzing →
        </button>
      </div>
    </div>
  );
}
